import React, { useEffect, useState } from "react";

const AddAddress = ({ onCancel }) => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        address: "",
        // address2: "",
        // address3: "",
        locality: "",
        city: "",
        district: "",
        // state: "",
        pincode: "",
        addressType: "Home",
        ledcode: "",
    });

    useEffect(() => {
        const ledcode = localStorage.getItem("Ledcode");
        if (ledcode) {
            setFormData((prev) => ({ ...prev, ledcode }));
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // const fullAddress = `${formData.address1}, ${formData.address2}, ${formData.address3}`.replace(/(, )+/g, ", ").replace(/^,|,$/g, "");

        const payload = {
            name: formData.name.trim(),
            mobile: formData.mobile.trim(),
            pincode: formData.pincode.trim(),
            locality: formData.locality.trim(),
            address: formData.address.trim(),
            city: formData.city.trim(),
            district: formData.district.trim(),
            addressType: formData.addressType,
            ledcode: formData.ledcode,
        };

        console.log(payload);

        // Basic required field check
        const requiredFields = [
            "name",
            "mobile",
            "pincode",
            "locality",
            "address",
            "city",
            "district",
            "addressType",
            "ledcode",
        ];
        const hasEmpty = requiredFields.some((field) => !payload[field]);
        if (hasEmpty) {
            alert("Please fill in all required fields.");
            return;
        }

        try {
            setLoading(true);
            const response = await fetch(`${apiBaseUrl}/user/addAddress/JAPAN_ACCESORIES`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            if (response.ok) {
                alert("Address saved successfully!");
                handleCancel();
            } else {
                alert(data.error || "Failed to save address.");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error saving address:", error);
            alert("Something went wrong while saving the address.");
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setFormData({
            name: "",
            mobile: "",
            address: "",
            // address2: "",
            // address3: "",
            locality: "",
            city: "",
            district: "",
            // state: "",
            pincode: "",
            addressType: "Home",
            ledcode: localStorage.getItem("Ledcode") || "",
        });
        onCancel();
    };

    return (
        <div>
            <form
                onSubmit={handleSubmit}
                className="w-full grid md:grid-cols-2 gap-1 lg:gap-4 p-7 border border-[#b8b8b9] rounded-md shadow bg-[white] z-10 md:absolute"
            >
                <input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Full Name"
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                />
                <input
                    name="mobile"
                    value={formData.mobile}
                    onChange={(e) => /^\d*$/.test(e.target.value) && handleChange(e)}
                    placeholder="Mobile Number"
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                />
                <input
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Address Line 1"
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                />
                <input
                    name="locality"
                    value={formData.locality}
                    onChange={handleChange}
                    placeholder="Locality"
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                />
                <input
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="City"
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                />
                <input
                    name="district"
                    value={formData.district}
                    onChange={handleChange}
                    placeholder="District"
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                />
                <input
                    name="pincode"
                    value={formData.pincode}
                    onChange={(e) => /^\d*$/.test(e.target.value) && handleChange(e)}
                    placeholder="Pincode"
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                />
                <select
                    name="addressType"
                    value={formData.addressType}
                    onChange={handleChange}
                    className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                >
                    <option value="Home">Home</option>
                    <option value="Office">Office</option>
                    <option value="Other">Other</option>
                </select>

                <div className="w-full mb-2 md:col-span-2 flex justify-end gap-4">
                    <button
                        type="button"
                        onClick={handleCancel}
                        className="border-2 text-[#b42446] rounded text-sm font-medium px-3 py-1 flex items-center gap-1"
                    >
                        Cancel
                    </button>
                    <button
                        disabled={loading}
                        type="submit"
                        className="border-2 text-[#663dee] rounded text-sm font-medium px-3 py-1 flex items-center gap-1"
                    >
                        {loading ? "Saving..." : "Save Address"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddAddress;
